import React from "react"
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { logout } from 'data/auth/action'
import error_saur from 'img/error_icon.png'
import './style.css'

class ErrorPage extends React.Component{
  constructor(props) {
    super(props)
    props.logout()
  }

  render(){
    return(
      <div className="ErrorScreen">
        <div className="ErrorMessage">
          <img id='error_saur' src={error_saur} alt='Error' />
          <div>We seem to have experienced an issue.</div>
          <div>Please login and try again, if this continues please contact us.</div>
          <div><Link className="emailLink" to='mailto:accounts@retirementnavigator.ca'>accounts@retirementnavigator.ca</Link></div>
          <div><Link className='loginLink' to='/login' tabIndex={-1}>Return to Login</Link></div>
        </div>
      </div>
    )
  }
}

export default connect(null, { logout } )(ErrorPage)
